import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const UserIcon = (props: IconProps) => {
  const { color = FORTA_BLUE.primary, width = 24, height = 24, viewBox = '0 0 24 24' } = props;

  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox={`${viewBox}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" fill="none" />
      <path
        d="M12.0005 12C10.9005 12 9.95882 11.6083 9.17549 10.825C8.39216 10.0417 8.00049 9.1 8.00049 8C8.00049 6.9 8.39216 5.95833 9.17549 5.175C9.95882 4.39167 10.9005 4 12.0005 4C13.1005 4 14.0422 4.39167 14.8255 5.175C15.6088 5.95833 16.0005 6.9 16.0005 8C16.0005 9.1 15.6088 10.0417 14.8255 10.825C14.0422 11.6083 13.1005 12 12.0005 12ZM18.0005 20H6.00049C5.45049 20 4.97966 19.8042 4.58799 19.4125C4.19632 19.0208 4.00049 18.55 4.00049 18V17.2C4.00049 16.6333 4.14632 16.1125 4.43799 15.6375C4.72965 15.1625 5.11715 14.8 5.60049 14.55C6.63382 14.0333 7.68382 13.6458 8.75049 13.3875C9.81715 13.1292 10.9005 13 12.0005 13C13.1005 13 14.1838 13.1292 15.2505 13.3875C16.3172 13.6458 17.3672 14.0333 18.4005 14.55C18.8838 14.8 19.2713 15.1625 19.563 15.6375C19.8547 16.1125 20.0005 16.6333 20.0005 17.2V18C20.0005 18.55 19.8047 19.0208 19.413 19.4125C19.0213 19.8042 18.5505 20 18.0005 20ZM6.00049 18H18.0005V17.2C18.0005 17.0167 17.9547 16.85 17.863 16.7C17.7713 16.55 17.6505 16.4333 17.5005 16.35C16.6005 15.9 15.6922 15.5625 14.7755 15.3375C13.8588 15.1125 12.9338 15 12.0005 15C11.0672 15 10.1422 15.1125 9.22549 15.3375C8.30882 15.5625 7.40049 15.9 6.50049 16.35C6.35049 16.4333 6.22966 16.55 6.13799 16.7C6.04632 16.85 6.00049 17.0167 6.00049 17.2V18ZM12.0005 10C12.5505 10 13.0213 9.80417 13.413 9.4125C13.8047 9.02083 14.0005 8.55 14.0005 8C14.0005 7.45 13.8047 6.97917 13.413 6.5875C13.0213 6.19583 12.5505 6 12.0005 6C11.4505 6 10.9797 6.19583 10.588 6.5875C10.1963 6.97917 10.0005 7.45 10.0005 8C10.0005 8.55 10.1963 9.02083 10.588 9.4125C10.9797 9.80417 11.4505 10 12.0005 10Z"
        fill={`${color}`}
      />
    </svg>
  );
};

export default UserIcon;
